import { createRoot } from 'react-dom/client'
import App from './App'

document.addEventListener('DOMContentLoaded', function () {
	const container = document.getElementById('app-home-page')
	const root = createRoot(container)
	root.render(<App />)
})
